/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Notverified2Inputs */

const id_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Terverifikasi`)
};

const ms_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Disahkan`)
};

const da_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke Bekræftede`)
};

const de_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht Verifiziert`)
};

const en_us2_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Verified`)
};

const es_es2_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No verificadas`)
};

const es_mx2_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No verificadas`)
};

const fil_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi Na-verify`)
};

const fr_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non vérifiés`)
};

const it_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non verificate`)
};

const hu_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem hitelesített`)
};

const nl_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet geverifieerd`)
};

const no_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke bekreftet`)
};

const pl_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezweryfikowane`)
};

const pt_br2_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não verificado`)
};

const pt_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não verificadas`)
};

const ro_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neverificate`)
};

const fi_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vahvistetut`)
};

const sv_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ej verifierade`)
};

const vi_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xác minh`)
};

const tr_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulanmamış`)
};

const cs_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neověřené`)
};

const bg_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непроверени`)
};

const ru_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неподтверждённые`)
};

const uk_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не перевірені`)
};

const ar_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير موثقة`)
};

const hi_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापित नहीं`)
};

const th_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ได้รับการยืนยัน`)
};

const ja_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未確認`)
};

const zh_cn2_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未验证`)
};

const zh_hant1_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未驗證`)
};

const ko_offerdetail_reviews_notverified2 = /** @type {(inputs: Offerdetail_Reviews_Notverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증되지 않음`)
};

/**
* | output |
* | --- |
* | "Not Verified" |
*
* @param {Offerdetail_Reviews_Notverified2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_notverified2 = /** @type {((inputs?: Offerdetail_Reviews_Notverified2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Notverified2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_notverified2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_notverified2(inputs)
	if (locale === "da") return da_offerdetail_reviews_notverified2(inputs)
	if (locale === "de") return de_offerdetail_reviews_notverified2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_notverified2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_notverified2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_notverified2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_notverified2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_notverified2(inputs)
	if (locale === "it") return it_offerdetail_reviews_notverified2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_notverified2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_notverified2(inputs)
	if (locale === "no") return no_offerdetail_reviews_notverified2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_notverified2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_notverified2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_notverified2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_notverified2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_notverified2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_notverified2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_notverified2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_notverified2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_notverified2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_notverified2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_notverified2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_notverified2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_notverified2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_notverified2(inputs)
	if (locale === "th") return th_offerdetail_reviews_notverified2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_notverified2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_notverified2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_notverified2(inputs)
	return ko_offerdetail_reviews_notverified2(inputs)
});
export { offerdetail_reviews_notverified2 as "offerDetail.reviews.notVerified" }